import { initializeApp } from "firebase/app"; 
import { getAuth, initializeAuth, browserLocalPersistence } from "firebase/auth"; 
// Correction: On importe initializeFirestore et getFirestore (Fallback)
// On retire l'import de 'IndexedDbPersistence' qui causait l'erreur de compilation.
import { initializeFirestore, getFirestore } from "firebase/firestore"; 
import { getStorage } from "firebase/storage"; 

// Votre configuration Firebase (inchangée)
const firebaseConfig = {
    apiKey: "AIzaSyB-lQleiwU2gvLcZwyIUljZc1XY4QHv2w8",
    authDomain: "jangal-pro-1b256.firebaseapp.com",
    projectId: "jangal-pro-1b256",
    storageBucket: "jangal-pro-1b256.firebasestorage.app",
    messagingSenderId: "298697435444",
    appId: "1:298697435444:web:ec642f3e0c5fe88f139d61",
    measurementId: "G-YQ1QT1B9HZ"
};

// 1. Initialiser Firebase App
const app = initializeApp(firebaseConfig);


// 2. Initialiser Firebase Auth avec Persistance Locale
let auth;
try {
    auth = initializeAuth(app, {
        persistence: browserLocalPersistence 
    });
    console.log("✅ Firebase Auth persistance locale activée.");
} catch (e) {
    if (e.code === 'auth/already-initialized') {
        auth = getAuth(app);
    } else {
        console.error("⚠️ Erreur lors de l'initialisation de Firebase Auth avec persistance:", e);
        auth = getAuth(app); 
    }
}


// 3. Initialiser Firestore et configurer la persistance hors-ligne (Méthode moderne)
let db;
try {
    // initializeFirestore remplace getFirestore() + enableIndexedDbPersistence()
    // On utilise l'objet de configuration simple pour la persistance 
    // afin d'éviter l'erreur d'importation.
    db = initializeFirestore(app, {
        cache: {
            // 'persistent' active l'IndexedDB persistence (comportement par défaut)
            type: 'persistent' 
        }
    });
    console.log("✅ Firestore Persistance Hors Ligne configurée via initializeFirestore.");

} catch (e) {
    // Gestion des erreurs d'initialisation de la persistance (conflit, navigateur non supporté)
    if (e.code === 'failed-precondition' || e.code === 'unimplemented') {
        console.warn(`⚠️ Firestore: Persistance non activée. Cause: ${e.code}. Récupération de l'instance non persistante.`);
        db = getFirestore(app); 
    } else {
        console.error("⚠️ Erreur lors de l'initialisation de Firestore avec persistance :", e);
        db = getFirestore(app);
    }
}


// 4. Initialiser Storage
const storage = getStorage(app);

// 5. Export des instances
export { auth, db, storage };

